import { render, staticRenderFns } from "./HabeasDataDetailsIcon.vue?vue&type=template&id=bc0fa946&"
import script from "./HabeasDataDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./HabeasDataDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports